import { render, staticRenderFns } from "./Index_Dash.vue?vue&type=template&id=4d0ad3dc&"
import script from "./Index_Dash.vue?vue&type=script&lang=js&"
export * from "./Index_Dash.vue?vue&type=script&lang=js&"
import style0 from "./Index_Dash.vue?vue&type=style&index=0&id=4d0ad3dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports